import { Instagram, Mail, Phone, MessageCircle, MapPin } from "lucide-react";
import { CONTACT } from "@/constants/testIds";

const CHANNELS = [
  {
    href: "mailto:indiorajourneys@gmail.com",
    icon: Mail,
    label: "indiorajourneys@gmail.com",
    testId: CONTACT.emailLink,
    hover: "hover:text-indigo_deep",
  },
  {
    href: "tel:+918287828387",
    icon: Phone,
    label: "+91 82878 28387",
    testId: "contact-phone-link",
    hover: "hover:text-indigo_deep",
  },
  {
    href: "https://wa.me/918287828387",
    icon: MessageCircle,
    label: "Chat on WhatsApp",
    testId: "contact-whatsapp-link",
    hover: "hover:text-monsoon",
    external: true,
  },
  {
    href: "https://instagram.com/indiorajourneys",
    icon: Instagram,
    label: "@indiorajourneys",
    testId: CONTACT.instagramLink,
    hover: "hover:text-indigo_deep",
    external: true,
  },
];

export default function ContactAside() {
  return (
    <aside className="col-span-12 md:col-span-4 md:col-start-9 md:border-l md:border-line-dark md:pl-12">
      <div className="eyebrow mb-6">Or write to us directly</div>
      {CHANNELS.map(({ href, icon: Icon, label, testId, hover, external }, idx) => (
        <a
          key={href}
          href={href}
          data-testid={testId}
          {...(external ? { target: "_blank", rel: "noreferrer" } : {})}
          className={`group flex items-center gap-4 text-xl font-serif italic ${hover} transition-colors ${idx === CHANNELS.length - 1 ? "mb-16" : "mb-6"}`}
        >
          <Icon size={18} strokeWidth={1.3} />
          {label}
        </a>
      ))}

      <div className="text-[10px] tracking-widest3 uppercase text-ink/50 mb-4">
        Curator hours
      </div>
      <p className="text-ink/70 font-light leading-relaxed mb-10">
        Monday — Saturday, 9am to 7pm IST.<br />
        Personal replies, always.
      </p>

      <div className="text-[10px] tracking-widest3 uppercase text-ink/50 mb-4">
        Atelier
      </div>
      <address
        data-testid="contact-address"
        className="not-italic flex items-center gap-3 text-ink/75 font-light leading-relaxed mb-10"
      >
        <MapPin size={16} strokeWidth={1.3} className="shrink-0 text-terracotta" />
        <span>C-28-A, Vishwakarma Colony, New Delhi — 110044, India</span>
      </address>

      <div className="text-[10px] tracking-widest3 uppercase text-ink/50 mb-4">
        Where we travel
      </div>
      <p className="text-ink/70 font-light leading-relaxed">
        India · Nepal · Bhutan · Sri Lanka
      </p>
    </aside>
  );
}
